<template>
  <v-dialog v-model="dialog" max-width="520px" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon left color="red">
          mdi-delete-alert
        </v-icon>
        Eliminar Proveedor
      </v-card-title>

      <v-card-text>
        <v-alert
          type="error"
          prominent
          text
          class="mb-4"
        >
          Está a punto de <strong>ELIMINAR</strong> este proveedor. Esta acción no se puede deshacer.
        </v-alert>

        <div>
          <v-row dense>
            <v-col cols="12">
              <div class="text-subtitle-2 grey--text">Clave</div>
              <div class="text-body-1 font-weight-medium">
                {{ editedItem.clave || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="12" class="mt-2">
              <div class="text-subtitle-2 grey--text">Nombre Completo</div>
              <div class="text-body-1 font-weight-medium">
                {{ editedItem.nombre_completo || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="12" class="mt-2">
              <div class="text-subtitle-2 grey--text">RFC</div>
              <div class="text-body-1">
                {{ editedItem.rfc || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="12" class="mt-2">
              <div class="text-subtitle-2 grey--text">Tipo de Proveedor</div>
              <div class="text-body-1">
                {{ editedItem.nombre_proveedor_tipo || 'N/A' }}
              </div>
            </v-col>
          </v-row>
        </div>

        <br>

        <div class="text-body-1">
          ¿Está seguro de realizar esta acción?
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          text
          color="grey"
          @click="cancelar"
          :disabled="loading"
        >
          Cancelar
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          text
          color="red"
          :loading="loading"
          :disabled="loading"
          @click="confirmar"
        >
          Eliminar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DialogoEliminarProveedor',

  data() {
    return {
      dialog: false,
      loading: false,
      editedItem: {
        id_proveedor: null,
        clave: '',
        nombre_completo: '',
        rfc: '',
        nombre_proveedor_tipo: '',
      },
      defaultEditedItem: {
        id_proveedor: null,
        clave: '',
        nombre_completo: '',
        rfc: '',
        nombre_proveedor_tipo: '',
      }
    }
  },

  methods: {
    open(item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    cancelar() {
      this.dialog = false
      this.loading = false
      this.editedItem = Object.assign({}, this.defaultEditedItem)
    },

    async confirmar() {
      if (!this.editedItem?.id_proveedor) return

      this.loading = true

      axios
        .delete(`/Proveedores/EliminarProveedor/${this.editedItem.id_proveedor}`)
        .then(() => {
          this.cancelar()
          this.$emit('change', null)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
